import {
  React,
  Component,
  withCookies,
  axios,
  routes,
  helpers,
} from 'imports/CommonImports';

import {
  PostulationFormWithSteps,
  NoPostulatedProjects,
} from 'imports/ComponentsImports';

import {
  ModalWithChildren,
  LoadingDialog,
  AlertDialog,
  AlertDialogOneButton,
} from 'imports/DesignImports';

import {
  DeleteIcon,
  DoneIcon,
  ViewIcon,
  ExpandMoreIcon,
} from 'imports/IconsImports';

import {
  FlatButton,
  IconButton,
  List,
  ListItem,
  Paper,
} from 'material-ui';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  list: {
    padding: '0px'
  },
  listItemHeader: {
    backgroundColor: '#F0F0EF',
  },
  listHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Lato'
  },
  listHeader: {
    marginRight:'0.5em'
  },
  listItem: {
    borderBottom: '2px #F0F0EF solid',
  },
  listItemContainer: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Lato'
  },
  flex1:{
    flex: '1'
  },
  flex2:{
    flex: '2'
  },
  flex3: {
    flex: '3'
  },
  flexFullCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconButton: {
    color: '#212F55'
  },
  sendButton: {
    border: '1px solid #11AB99',
    color: 'white',
    textAlign: 'center',
    borderRadius: '0px',
    backgroundColor: '#11AB99',
    fontFamily: 'lato'
  },
  sendButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2em',
  }
}

class PostulatedList extends Component {
  constructor(props){
    super(props)
    this.state = {
      reverseSort: {
        name: false,
        area: false,
        leader: false,
        economicImpact: false,
        year: false
      },
      projects: props.projects || [],
      doneProjects: props.doneProjects || [],
      project: null,
      loadingDialog: false,
      alertDialog: false,
      alertDialogOneButton: false,
      alertMessage: '',
      token:this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
    }
  }

  render() {
    if(this.state.projects.length <= 0 && this.props.done)
      return (
        <NoPostulatedProjects
          message={
            this.state.user.position === 'Gerente Innovación' ?
            'No se postularon proyectos, habla con los consultores de INNSPIRAL para volver a la etapa de postulación':
            'No se postularon proyectos para tu área'
          }/>
      )
    else
      return(
        <div style={styles.container}>
        <List style={styles.list}>
        <Paper zDepth={1} style={{marginBottom: '10px'}}>
          <ListItem
          disabled={true}
          style={styles.listItemHeader}
          innerDivStyle={{padding: '1em 0.5em'}}
          primaryText={
            <div style={styles.listHeaderContainer}>
              <div style={{...styles.flex3, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={styles.listHeader}>Nombre del Proyecto </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('name')} > <ExpandMoreIcon/></IconButton>
              </div>
              <div style={{...styles.flex1, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={styles.listHeader}>Área </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('area')} > <ExpandMoreIcon/></IconButton>
              </div>
              <div style={{...styles.flex2, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={styles.listHeader}>Líder </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('leader')} > <ExpandMoreIcon/></IconButton>
              </div>
              <div style={{...styles.flex1, ...{alignItems: 'center', display: 'flex'}}}>
                <div style={styles.listHeader}>Implementación </div>
                <IconButton style={{padding: '0px', height: '24px', width: '24px'}} onClick={() => this.orderProjectsBy('year')} > <ExpandMoreIcon/></IconButton>
              </div>
              <div style={{...styles.flex1, ...styles.flexFullCenter}}>Acción</div>
            </div>
          } />
          </Paper>
          <Paper zDepth={1}>
          {this.state.projects.map((project, i) => {
            return (
              <ListItem
                key={i}
                onClick={() => {this.setState({project: project, position: i})}}
                style={styles.listItem}
                innerDivStyle={{padding: '0 0.5em'}}
                primaryText={
                <div style={styles.listItemContainer}>
                  <div style={styles.flex3}>{project.information.name}</div>
                  <div style={styles.flex1}>{project.information.area.name}</div>
                  <div style={styles.flex2}>
                    {
                      (project.information.leader_first_name + ' ' + project.information.leader_last_name)}
                  </div>
                  <div style={{...styles.flex1, ...{textAlign: 'right', paddingRight: '2em'}}}>{project.information.start_date.split('-')[0]}</div>
                  <div style={{...styles.flex1, ...styles.flexFullCenter}}>
                    <IconButton tooltip="Ver"
                      style={styles.iconButton}
                      onClick={(event) => {event.stopPropagation(); this.setState({project: project, position: i})}}
                      >
                      <ViewIcon />
                    </IconButton>
                  </div>
                </div>
              }
              />
            );
            })
          }
          {this.state.doneProjects.map((project, i) => {
            return (
              <ListItem
                key={i}
                onClick={() => {this.setState({project: project, position: i})}}
                style={styles.listItem}
                innerDivStyle={{padding: '0 0.5em'}}
                primaryText={
                <div style={styles.listItemContainer}>
                  <DoneIcon />
                  <div style={styles.flex3}>{project.information.name}</div>
                  <div style={styles.flex1}>{project.information.area.name}</div>
                  <div style={styles.flex2}>
                    {
                      (project.information.leader_first_name + ' ' + project.information.leader_last_name)}
                  </div>
                  <div style={{...styles.flex1, ...{textAlign: 'right', paddingRight: '2em'}}}>{helpers.numberWithDots(project.information.economic_impact)}</div>
                  <div style={{...styles.flex1, ...{textAlign: 'right', paddingRight: '2em'}}}>{project.information.start_date.split('-')[0]}</div>
                  <div style={{...styles.flex1, ...styles.flexFullCenter}}>
                    <IconButton tooltip="Ver"
                      style={styles.iconButton}
                      onClick={(event) => {event.stopPropagation(); this.setState({project: project, position: i})}}
                      >
                      <ViewIcon />
                    </IconButton>
                    <IconButton tooltip="Eliminar"
                      style={styles.iconButton}
                      onClick={(event) => {event.stopPropagation(); this.setState({alertDialog: true, alertMessage: '¿Estás seguro que quieres eliminar la postulación?', confirm: () => this.deletePostulation(project, i)})}}
                      >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                </div>
              }
              />
            );
            })
          }
          </Paper>
            { this.state.project ?
              <ModalWithChildren
                project={this.state.project}
                children={
                  <PostulationFormWithSteps
                    project={this.state.project}
                    currency={this.state.user.company_currency}
                    filterData={this.props.filterData}
                    />}
                cancel={() => this.setState({project: null})}/>
              : null}
            { this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento" /> : null }
            { this.state.alertDialog ?
              <AlertDialog
                title='¡Atención!'
                message={this.state.alertMessage}
                acceptLabel='Sí, enviar'
                cancelLabel='No, volver'
                confirm={this.state.confirm}
                cancel={() => this.setState({alertDialog: false})}/> : null}
            { this.state.alertDialogOneButton ?
              <AlertDialogOneButton
                title={this.state.alertTitle}
                message={this.state.alertMessage}
                acceptLabel='Aceptar'
                confirm={this.state.confirm}/> : null}
          </List>
          {this.props.withButton ?
            <div style={styles.sendButtonContainer}>
              <FlatButton style={styles.sendButton}
                onClick={() => this.setState({alertDialog: true, alertMessage: '¿Estás seguro que quieres enviar los proyectos? Una vez que lo hagas no podrás enviar ninguno más', confirm: this.send})}
                label="Aprobar Postulaciones"/>
            </div>
            : null }
          </div>
        )
    }

    deletePostulation = (project, i) => {
      this.setState({loadingDialog: true})
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.delete(routes.deleteProjectPostulation(this.state.user.company_id, null, project.id))
      .then((response) => {
        var newState = this.state;
        newState.alertDialogOneButton = true;
        newState.alertMessage = 'Proyecto eliminado con éxito';
        newState.alertTitle = '¡Felicidades!';
        newState.confirm = () => this.setState({alertDialogOneButton: false});
        newState.alertDialog = true;
        newState.loadingDialog = false;
        newState.projects.splice(i, 1);
        this.setState(newState);
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alertDialogOneButton: true,
          alertMessage: 'No se pudo eliminar el proyecto, intenta nuevamente',
          confirm: () => this.setState({alertDialogOneButton: false}),
          loadingDialog: false,
          alertDialog: false,
        })
      });
    }

    patchProject = (project, i) => {
      console.log(project);
      this.setState({loadingDialog: true})
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.patch(routes.patchProjectPostulation(project.id), project)
      .then((response) => {
        this.setState({
          alertDialogOneButton: true,
          alertMessage: 'Proyecto modificado con éxito',
          alertTitle: '¡Felicidades!',
          confirm: () => this.setState({alertDialogOneButton: false}),
          loadingDialog: false,
        });
        this.reloadProject(response.data, i);
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alertDialogOneButton: true,
          alertMessage: 'Hubo un error al modificar el proyecto, intenta nuevamente',
          confirm: () => this.setState({alertDialogOneButton: false}),
          loadingDialog: false,
          project: null,
        })
      });
    }

    send = () => {
      this.setState({alertDialog: false, loadingDialog: true})
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.post(routes.approveProjects(this.state.user.company_id), this.state.projects)
      .then((response) => {
        this.setState({
          alertDialogOneButton: true,
          alertTitle: '¡Felicidades!',
          alertMessage: 'Se enviaron los proyectos con éxito',
          confirm: () => window.location.reload(),
          loadingDialog: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          alertDialogOneButton: true,
          alertMessage: 'Hubo un error al modificar el proyecto, intenta nuevamente',
          confirm: () => this.setState({alertDialogOneButton: false}),
          loadingDialog: false,
        })
      });
    }

    orderProjectsBy = (type) => {
      var reverseSort = this.state.reverseSort;
      var projects = this.state.projects;
      var temp = reverseSort[type];
      for (var key in reverseSort) {
        if (reverseSort.hasOwnProperty(key)) {
          reverseSort[key] = false;
        }
      }
      reverseSort[type] = !temp;
      reverseSort[type] ? projects.sort(helpers.comparers.reverse[type]) : projects.sort(helpers.comparers[type]);
      this.setState({
        projects: projects,
        reverseSort: reverseSort
      })
    }

    reloadProject = (project, i) => {
      var newState = this.state;
      newState.project = null;
      newState.projects[i] = project;
      this.setState(newState);
    }
  }

export default withCookies(PostulatedList);



// WEBPACK FOOTER //
// ./src/components/postulation/PostulatedList.js